import { Link } from "react-router-dom";
import { Heart, MapPin, Star } from "lucide-react";
import { useState } from "react";
import { formatINR } from "@/lib/api";
import { STAYS } from "@/constants/testIds";

export default function PropertyCard({ p, eager = false }) {
  const [wished, setWished] = useState(false);
  return (
    <Link
      to={`/stays/${p.slug}`}
      data-testid={STAYS.card(p.slug)}
      className="group block bg-white rounded-2xl overflow-hidden soft-shadow hover:luxe-shadow transition-all duration-500 hover:-translate-y-1 border border-forest/[0.06]"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-forest-50">
        <img
          src={p.images?.[0]}
          alt={p.name}
          loading={eager ? "eager" : "lazy"}
          className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-[1200ms] ease-out"
        />
        <div className="absolute top-4 left-4 flex items-center gap-1.5 bg-ivory/95 backdrop-blur px-3 py-1.5 rounded-full text-xs font-semibold text-forest">
          <Star className="h-3.5 w-3.5 fill-ember stroke-ember" /> <span className="num">{p.rating?.toFixed(1)}</span>
        </div>
        {!p.is_bookable && (
          <div className="absolute bottom-4 left-4 bg-forest-900/85 backdrop-blur text-ivory px-3 py-1.5 rounded-full text-[10px] uppercase tracking-[0.22em] font-semibold">
            Coming Soon
          </div>
        )}
        <button
          onClick={(e) => { e.preventDefault(); setWished(v => !v); }}
          className="absolute top-4 right-4 h-9 w-9 rounded-full bg-ivory/95 backdrop-blur grid place-items-center hover:scale-110 transition-transform"
          aria-label="Add to wishlist"
        >
          <Heart className={`h-4 w-4 transition-colors ${wished ? "fill-ember stroke-ember" : "stroke-forest"}`} />
        </button>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="font-serif text-lg md:text-xl text-ink truncate">{p.name}</h3>
            <div className="flex items-center gap-1.5 mt-1 text-xs text-ink-soft">
              <MapPin className="h-3.5 w-3.5 text-forest-400" />
              <span className="truncate">{p.destination}, {p.state}</span>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-forest/[0.08] flex items-baseline justify-between">
          <div>
            <span className="font-serif text-xl text-forest num">{formatINR(p.price_per_night)}</span>
            <span className="text-xs text-ink-soft ml-1">/ night</span>
          </div>
          <span className="text-[11px] tracking-[0.18em] uppercase text-forest font-medium">View →</span>
        </div>
      </div>
    </Link>
  );
}
